import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import propTypes from 'prop-types';
import { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';

const VoucherStep = ({ icon, iconTransform, title, children }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="step-content">
        <div className="icon">
          <FontAwesomeIcon icon={icon} transform={iconTransform} />
        </div>
        <div>
          <h2 className="title">{title}</h2>
          {children}
        </div>
      </div>
      <style jsx>{`
        .step-content {
          display: flex;
          align-items: flex-start;
          margin-bottom: 0;
        }
        .icon {
          display: none;
          color: #ccc;
          font-size: 4em;
          margin: 0 30px 0 5px;
        }
        .title {
          color: ${theme.colors.primary};
          font-weight: normal;
          font-size: 1.2em;
          margin-bottom: 0;
          text-transform: capitalize;
        }

        @media (min-width: ${theme.breakpoints.lgUp}) {
          .icon {
            display: block;
          }
        }
      `}</style>
    </>
  );
};

VoucherStep.propTypes = {
  children: propTypes.any,
  icon: propTypes.object,
  iconTransform: propTypes.object,
  title: propTypes.string,
};

export default VoucherStep;
